// extracted by mini-css-extract-plugin
export default {"gap_20":"ActionPopup_gap_20__s5gXy"};